<div class="offline-overlay" role="alertdialog" aria-modal="true">
  <div class="offline-card">
    <div class="offline-card__icon" aria-hidden="true">
      <span class="offline-card__ring"></span>
      <span class="offline-card__ring offline-card__ring--outer"></span>
      <i class="icon-wifi-off"></i>
    </div>

    <div class="offline-card__texts">
      <h2 class="offline-card__title text-lg-bold">اینترنت قطع شد</h2>
      <p class="offline-card__desc text-sm-regular">
        اتصال Wi‑Fi یا داده تلفن همراه خود را بررسی کنید و دوباره تلاش کنید.
      </p>
    </div>

    <button
      class="offline-card__btn"
      nttButton
      theme="solid"
      size="lg"
      [loading]="checking()"
      (click)="retry()"
    >
      تلاش مجدد
    </button>

    @if (failed()) {
      <p class="offline-card__error text-sm-regular" role="status">
        هنوز اتصالی پیدا نشد. لطفاً چند لحظه بعد دوباره تلاش کنید.
      </p>
    }
  </div>
</div>
